import { useState } from 'react';
import { Modal, Button } from '@components/ui';

export default function CustomerModal({ isOpen, onClose, onSubmit }) {
    const [formData, setFormData] = useState({
        name: '',
        phone: '',
        email: '',
        tcNo: '',
        address: '',
        role: 'customer',
        occupation: '',
        notes: '',
    });

    const handleSubmit = () => {
        onSubmit?.(formData);
        setFormData({
            name: '', phone: '', email: '', tcNo: '',
            address: '', role: 'customer', occupation: '', notes: '',
        });
        onClose();
    };

    const handleChange = (field, value) => {
        setFormData(prev => ({ ...prev, [field]: value }));
    };

    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            title="👤 Yeni Müşteri Ekle"
            size="md"
            footer={
                <>
                    <Button variant="ghost" onClick={onClose}>İptal</Button>
                    <Button variant="primary" onClick={handleSubmit}>Kaydet</Button>
                </>
            }
        >
            <div className="space-y-4">
                <div>
                    <label className="block text-sm font-medium text-text-secondary mb-1">Ad Soyad *</label>
                    <input
                        type="text"
                        className="w-full px-4 py-3 rounded-lg border border-border-light bg-bg-primary"
                        placeholder="Ahmet Yılmaz"
                        value={formData.name}
                        onChange={(e) => handleChange('name', e.target.value)}
                    />
                </div>

                <div className="grid grid-cols-2 gap-4">
                    <div>
                        <label className="block text-sm font-medium text-text-secondary mb-1">Telefon *</label>
                        <input
                            type="tel"
                            className="w-full px-4 py-3 rounded-lg border border-border-light bg-bg-primary"
                            placeholder="0532 123 4567"
                            value={formData.phone}
                            onChange={(e) => handleChange('phone', e.target.value)}
                        />
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-text-secondary mb-1">E-posta</label>
                        <input
                            type="email"
                            className="w-full px-4 py-3 rounded-lg border border-border-light bg-bg-primary"
                            placeholder="ornek@email.com"
                            value={formData.email}
                            onChange={(e) => handleChange('email', e.target.value)}
                        />
                    </div>
                </div>

                <div className="grid grid-cols-2 gap-4">
                    <div>
                        <label className="block text-sm font-medium text-text-secondary mb-1">TC Kimlik No</label>
                        <input
                            type="text"
                            className="w-full px-4 py-3 rounded-lg border border-border-light bg-bg-primary"
                            placeholder="12345678901"
                            value={formData.tcNo}
                            onChange={(e) => handleChange('tcNo', e.target.value)}
                        />
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-text-secondary mb-1">Rol</label>
                        <select
                            className="w-full px-4 py-3 rounded-lg border border-border-light bg-bg-primary"
                            value={formData.role}
                            onChange={(e) => handleChange('role', e.target.value)}
                        >
                            <option value="customer">Müşteri</option>
                            <option value="landowner">Arsa Sahibi</option>
                            <option value="investor">Yatırımcı</option>
                        </select>
                    </div>
                </div>

                <div>
                    <label className="block text-sm font-medium text-text-secondary mb-1">Meslek</label>
                    <input
                        type="text"
                        className="w-full px-4 py-3 rounded-lg border border-border-light bg-bg-primary"
                        placeholder="Mühendis"
                        value={formData.occupation}
                        onChange={(e) => handleChange('occupation', e.target.value)}
                    />
                </div>

                <div>
                    <label className="block text-sm font-medium text-text-secondary mb-1">Adres</label>
                    <input
                        type="text"
                        className="w-full px-4 py-3 rounded-lg border border-border-light bg-bg-primary"
                        placeholder="Adres..."
                        value={formData.address}
                        onChange={(e) => handleChange('address', e.target.value)}
                    />
                </div>

                <div>
                    <label className="block text-sm font-medium text-text-secondary mb-1">Not</label>
                    <textarea
                        className="w-full px-4 py-3 rounded-lg border border-border-light bg-bg-primary resize-none"
                        rows={2}
                        placeholder="Notlar..."
                        value={formData.notes}
                        onChange={(e) => handleChange('notes', e.target.value)}
                    />
                </div>
            </div>
        </Modal>
    );
}
